<div class="card custom-box mb-3">
  <div class="card-body">
    <div class="row my-3">
      <label class="col-xl-2 col-form-label">เลขประจำตัวประชาชน</label>
      <div class="col-xl-3">
        <input type="text" class="form-control">
      </div>
      <label class="col-xl-2 col-form-label ">หน่วยบริการ</label>
      <div class="col-xl-3">
        <select class="form-control col-lg-5">
          <option [ngValue]="undefined">ทั้งหมด</option>
        </select>
      </div>
    </div>
    <div class="row my-3">
      <label class="col-xl-2 col-form-label">ชื่อ</label>
      <div class="col-xl-3">
        <input type="text" class="form-control">
      </div>
      <label class="col-xl-2 col-form-label">นามสกุล</label>
      <div class="col-xl-3">
        <input type="text" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="text-center">
        <button type="button" (click)="search()" class="btn btn-default me-2">
          <i class="bi bi-search me-1"></i>ค้นหา
        </button>
        <button type="reset" class="btn btn-default me-2">
          เคลียร์ข้อมูล
        </button>
      </div>
    </div>
  </div>
</div>
<div class="row my-3">
  <div class="col">
    <div class="table-responsive">
      <table class="table table-sm caption-top border">
        <caption>
          แสดง {{ (pageData?.content?.length ? (pageData?.number * pageData?.size) + 1 : 0) | number }}
          ถึง {{ ((pageData?.number) * pageData?.size + pageData?.content?.length) | number }}
          จากทั้งหมด {{ pageData?.totalElements | number }} รายการ
        </caption>
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th nowrap scope="col">เลขประจำตัวประชาชน</th>
          <th nowrap scope="col" class="">ชื่อ</th>
          <th nowrap scope="col" class="">นามสกุล</th>
          <th nowrap scope="col" class="">หน่วยบริการที่ลงทะเบียน</th>
          <th nowrap scope="col" class="">วันที่เสียชีวิต</th>
        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr>
          <td class="text-muted text-center" colspan="5">
            <i class="bi bi-inbox"></i><br>
            ไม่พบข้อมูล
          </td>
        </tr>
        <tr>
          <td class="text-center"></td>
          <td class=""></td>
          <td class=""></td>
          <td class=""></td>
          <td class=""></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageData?.number + 1"
                    (pageChange)="search($event)"
                    [pageSize]="pageData?.size"
                    [collectionSize]="pageData?.totalElements"></ngb-pagination>
  </div>
</div>
